import {
  Modal,
  ModalOverlay,
  ModalBody,
  ModalContent,
  ModalCloseButton,
  Text,
  ModalHeader,
  ModalFooter,
  Button,
  Checkbox,
  Link,
} from '@chakra-ui/react';
import MerchantContext from '../contexts/MerchantContext';
import { useContext, useState } from 'react';
import AuthContext from '../contexts/AuthContext';
import { useTRPC } from '../trpc/client';
import CustomButton from './CustomButton';
import { DocumentType } from '../types';
import { useMutation } from '@tanstack/react-query';

type Props = {
  onClose: () => void;
  user: string;
  documentType?: DocumentType;
  documentNumber?: string;
  orgId?: string;
};

const TermsAgreementModal = ({ user, documentType, documentNumber, orgId, onClose }: Props): JSX.Element => {
  const trpc = useTRPC();
  const [isChecked, setIsChecked] = useState(false);
  const { merchant } = useContext(MerchantContext);
  const { login } = useContext(AuthContext);

  const acceptTermsMutation = useMutation({
    ...trpc.invoices.setTermsAccepted.mutationOptions(),
  });

  const handleAccept = async () => {
    const customer = await acceptTermsMutation.mutateAsync({
      documentNumber: documentNumber ?? '',
      rentalsMerchantId: merchant?.id ?? '',
    });

    if (customer.termsAccepted) {
      login(user, documentType, documentNumber, orgId);
    }
  };

  return (
    <Modal isOpen={!!documentNumber} onClose={onClose} isCentered={true} size={['md', 'md', 'lg', '2xl']}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader>Políticas de Tratamiento de la Información</ModalHeader>
        <ModalBody>
          <Text mb={4}>
            Por favor lee y acepta las{' '}
            <Link href={merchant?.termsUrl} color="main" fontWeight={600} isExternal>
              políticas de tratamiento de la información
            </Link>{' '}
            para continuar.
          </Text>
          <Checkbox colorScheme="green" isChecked={isChecked} onChange={(e) => setIsChecked(e.target.checked)}>
            He leído y acepto los términos y condiciones
          </Checkbox>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" onClick={onClose} isDisabled={acceptTermsMutation.isPending}>
            Declinar
          </Button>
          <CustomButton mr={3} onClick={handleAccept} isDisabled={!isChecked} isLoading={acceptTermsMutation.isPending}>
            Aceptar
          </CustomButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default TermsAgreementModal;
